import {
  canShowOwnedResource,
  type ResourceStatus,
} from '../scopedResource';

/** WorkTag 목록은 공개 GET /list 하나. owner/public scope 구분 없음. */
export const canShowWorkTagList = ({
  pageOwnerAui,
  listOwnerAui,
  status,
}: {
  pageOwnerAui: string | null | undefined;
  listOwnerAui: string | null;
  status: ResourceStatus;
}): boolean =>
  canShowOwnedResource({
    pageOwnerAui,
    resourceOwnerAui: listOwnerAui,
    status,
  });
